import { Company } from "models/company";
import { UserContact } from "models/user-contact";
import React from "react";
import { Modal } from "react-bootstrap";
import RoleSelectList from "./RoleSelectList";

interface RoleSelectModalProps {
    visible: boolean;
    hasActiveCustomer: boolean;
    onHide: () => void;
    onCustomerChange: (customerId: number, isPerson: boolean) => void;
    onRegister: (isCompany: boolean, company?: Company) => void;
    contacts: UserContact[];
    companies: Company[];
}

export default function RoleSelectModal(props: RoleSelectModalProps) {

    return (
        <Modal
            show={props.visible}
            size={"lg"}
            onHide={props.onHide}
            backdrop={'static'}
        >
            <Modal.Header>
            <Modal.Title>
                Esindatava valimine
            </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                <RoleSelectList 
                    contacts={props.contacts}
                    hasActiveCustomer={props.hasActiveCustomer}
                    companies={props.companies}
                    onCustomerChange={props.onCustomerChange}
                    onRegister={props.onRegister}
                />
            </Modal.Body>
        </Modal>
    );

}